//
//  I12VOLINSTCHAUFCalcul.js
//
//  Created by Sébastien Hecart on 2017-11-24 21:09:38 +0000.
//  Copyright © 2017 Sebastien Hecart. All rights reserved.
//
import { I12VOLINSTCHAUF_State } from '@batical/types/src'

function I12VOLINSTCHAUF_docalcul(state: I12VOLINSTCHAUF_State) {
  state.invalidated = false
  var result = 0.0
  result = state.ch_puissanceFonte + state.ch_puissanceAcier

  result += state.rad_panneau + state.rad_fonte + state.rad_alu + state.rad_conv + state.cond_bi + state.cond_mono
  if (state.in_dn > 0 && state.in_longeur > 0) {
    result += Math.pow(state.in_dn / 2 / 1000, 2) * Math.PI * state.in_longeur * 1000
  }
  return {
    ...state,
    result
  }
}

export default I12VOLINSTCHAUF_docalcul
